// sentry-loader.js
import * as Sentry from "@sentry/browser";

let _initialized = false;

/**
 * Initializes Sentry for browser-side error logging.
 * Safe to call multiple times.
 */
export function initSentryBrowser(options) {

    if (_initialized) return;

    Sentry.init({
        environment: options.environment ?? "development",
        dsn: options.frontendDsn,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: true
            }),
            Sentry.browserTracingIntegration(),
            //Sentry.browserProfilingIntegration()
        ],
        
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: options.replaysSessionSampleRate ?? 0.01,

        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: options.replaysOnErrorSampleRate ?? 0.1,

        tracesSampleRate: options.tracesSampleRate ?? 0,

        sendDefaultPii: true
    });

    _initialized = true;
}

// Optional: re-export Sentry so other modules can use captureException, etc.
//export { Sentry };